import { useState } from 'react'
import PropTypes from 'prop-types'

import { calcPoint, getUnusableAmount } from 'src/lib/item'
import { materialCategories } from 'src/pages/main/house/const/houseConstants'
import openExchangeConfirmModal from 'src/pages/main/shop/components/ShopExchangeTab/openExchangeConfirmModal'
import { useShopContext } from 'src/pages/main/shop/contexts/ShopContext'

import ItemListButton from 'src/components/menu/ItemListButton'
import { CategoryButtonGroup } from 'src/components/house/CategoryButtonGroup'
import NoContent from 'src/components/layouts/NoContent'
import Helper from 'src/pages/main/shop/components/ShopExchangeTab/Helper'
import ModalItemDetail from 'src/pages/main/shop/components/ShopExchangeTab/ModalItemDetail'

const ShopExchangeItem = ({ itemMaterial, selectedItem, remainPoint, handleChangeTab }) => {
  const [modalItemDetail, setModalItemDetail] = useState(null)
  const [modalItemOpen, setModalItemOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('background')
  const [selectedExchange, setSelectedExchange] = useState({})

  const {
    closeModal,
    setModalContent,
    setButtons,
    setTitle,
    refetchExchangeItem,
    refetchMaterialItem
  } = useShopContext()
  const totalPoints = calcPoint(remainPoint, selectedExchange)

  const handleClose = () => {
    setModalItemDetail(null)
    setModalItemOpen(false)
  }

  const handleModalItem = (item) => {
    setModalItemDetail(item)
    setModalItemOpen(true)
  }

  const handleConfirmAmount = (item, selectedAmount) => {
    setSelectedExchange((prev) => {
      const newList = { ...prev }
      if (selectedAmount === 0) {
        delete newList[item.id]
      } else {
        newList[item.id] = { amount: selectedAmount, rarity: item.rarity }
      }
      return newList
    })
  }

  const openConfirmModal = () =>
    openExchangeConfirmModal({
      selectedItem,
      selectedExchange,
      totalPoints,
      handleChangeTab,
      closeModal,
      setModalContent,
      setButtons,
      setTitle,
      refetchExchangeItem,
      refetchMaterialItem
    })

  const filteredMaterialItems = itemMaterial.filter((item) => {
    if (!selectedCategory) return true

    return item.category === selectedCategory && item.amount - getUnusableAmount(item) > 0
  })

  return (
    <div className="flex flex-col max-w-full bg-white h-full">
      <div className="p-2 flex justify-center">
        <CategoryButtonGroup
          categories={materialCategories}
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
        />
      </div>
      <div
        className={`flex-1 w-full overflow-y-auto hidden-scroll mx-2 ${
          filteredMaterialItems.length > 0
            ? 'grid grid-cols-5 gap-1 content-start'
            : 'flex items-center'
        }`}
      >
        {filteredMaterialItems.length > 0 ? (
          filteredMaterialItems.map((item) => (
            <div key={item.id} className="relative">
              <ItemListButton
                amount={item.amount - getUnusableAmount(item)}
                image={item?.icon_url}
                name={item.avatar_name}
                onClick={() => handleModalItem(item)}
                type="standard"
                rarity
              />

              {selectedExchange[item.id] && (
                <div
                  className="absolute top-0 right-0 xs:right-4 bg-cotton-candy-pink text-white text-[10px] font-bold
        w-5 h-5 rounded-full flex items-center justify-center z-10"
                >
                  {selectedExchange[item.id].amount}
                </div>
              )}
            </div>
          ))
        ) : (
          <NoContent message={'お持ちの\nアイテムがありません'} />
        )}
      </div>
      <div className="flex items-center justify-between m-1">
        <Helper
          point={selectedItem.material_points}
          itemName={selectedItem.item_name}
          currentPoint={totalPoints}
        />
        <button
          className="text-white bg-candy-pink font-Inter text-xs px-1 xs:px-8 py-3 rounded-md disabled:bg-metallic-gray"
          onClick={openConfirmModal}
          disabled={totalPoints < selectedItem.material_points}
        >
          交換する
        </button>
      </div>
      {modalItemDetail && (
        <ModalItemDetail
          open={modalItemOpen}
          item={modalItemDetail}
          handleClose={handleClose}
          handleConfirmAmount={handleConfirmAmount}
          currentAmount={selectedExchange[modalItemDetail.id]?.amount ?? 1}
        />
      )}
    </div>
  )
}

ShopExchangeItem.propTypes = {
  itemMaterial: PropTypes.array.isRequired,
  selectedItem: PropTypes.object.isRequired,
  remainPoint: PropTypes.number.isRequired,
  handleChangeTab: PropTypes.func.isRequired
}

export default ShopExchangeItem
